import { AcademyCourse } from '../../models/academy-course.model';

export const moreRequestsCourse: AcademyCourse = {
  slug: 'get-more-requests',
  trainingModuleId: 'get_lessons',
  titleKey: 'texts.Tutor_Academy_Course_More_Requests_Title',
  descriptionKey: 'texts.Tutor_Academy_Course_More_Requests_Description',
  isMandatory: false,
  hasSearchBoost: true,
  lessons: [
    {
      id: 'zorg-dat-je-gevonden-wordt',
      titleKey: 'texts.Tutor_Academy_MoreRequests_L1_Title',
      subtitleKey: 'texts.Tutor_Academy_MoreRequests_L1_Subtitle',
      type: 'text',
      blocks: [
        {
          type: 'paragraph',
          textKey: 'texts.Tutor_Academy_MoreRequests_L1_Paragraph1',
          linkLabelKey: 'texts.Tutor_Academy_MoreRequests_Profile_Label',
          linkParam: 'editProfile',
          linkUrl: '/Misc_tutor_edit_profile'
        },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_MoreRequests_L1_Paragraph2' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_MoreRequests_L1_Paragraph3' }
      ]
    },
    {
      id: 'vakken-en-leerjaren',
      titleKey: 'texts.Tutor_Academy_MoreRequests_L2_Title',
      subtitleKey: 'texts.Tutor_Academy_MoreRequests_L2_Subtitle',
      headingKey: 'texts.Tutor_Academy_MoreRequests_L2_Heading',
      type: 'text',
      blocks: [
        {
          type: 'paragraph',
          textKey: 'texts.Tutor_Academy_MoreRequests_L2_Paragraph1',
          linkLabelKey: 'texts.Tutor_Academy_MoreRequests_Profile_Label',
          linkParam: 'editProfile',
          linkUrl: '/Misc_tutor_edit_profile'
        },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_MoreRequests_L2_Paragraph2' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_MoreRequests_L2_Paragraph3' },
        {
          type: 'list',
          itemKeys: [
            'texts.Tutor_Academy_MoreRequests_L2_Item1',
            'texts.Tutor_Academy_MoreRequests_L2_Item2'
          ]
        }
      ]
    },
    {
      id: 'wat-er-op-je-profiel-staat',
      titleKey: 'texts.Tutor_Academy_MoreRequests_L3_Title',
      subtitleKey: 'texts.Tutor_Academy_MoreRequests_L3_Subtitle',
      type: 'text',
      actionUrlKey: 'texts.Tutor_Academy_MoreRequests_L3_Download_Url',
      actionLabelKey: 'texts.Tutor_Academy_MoreRequests_L3_Action',
      blocks: [
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_MoreRequests_L3_Paragraph1' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_MoreRequests_L3_Paragraph2' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_MoreRequests_L3_Paragraph3' },
        {
          type: 'list',
          itemKeys: [
            'texts.Tutor_Academy_MoreRequests_L3_Item1',
            'texts.Tutor_Academy_MoreRequests_L3_Item2',
            'texts.Tutor_Academy_MoreRequests_L3_Item3'
          ]
        },
        {
          type: 'paragraph',
          textKey: 'texts.Tutor_Academy_MoreRequests_L3_Paragraph4',
          linkLabelKey: 'texts.Tutor_Academy_MoreRequests_Profile_Label',
          linkParam: 'editProfile',
          linkUrl: '/Misc_tutor_edit_profile'
        }
      ]
    },
    {
      id: 'hoger-in-de-lijst',
      titleKey: 'texts.Tutor_Academy_MoreRequests_L4_Title',
      subtitleKey: 'texts.Tutor_Academy_MoreRequests_L4_Subtitle',
      type: 'text',
      blocks: [
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_MoreRequests_L4_Paragraph1' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_MoreRequests_L4_Paragraph2' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_MoreRequests_L4_Paragraph3' }
      ]
    }
  ],
  quiz: [
    {
      id: 'weinig-aanvragen',
      questionKey: 'texts.Tutor_Academy_MoreRequests_Q1_Question',
      isMultiSelect: false,
      answers: [
        { id: 'langere-tekst', textKey: 'texts.Tutor_Academy_MoreRequests_Q1_Answer1' },
        { id: 'instellingen-checken', textKey: 'texts.Tutor_Academy_MoreRequests_Q1_Answer2' },
        { id: 'reisafstand', textKey: 'texts.Tutor_Academy_MoreRequests_Q1_Answer3' },
        { id: 'afwachten', textKey: 'texts.Tutor_Academy_MoreRequests_Q1_Answer4' }
      ],
      correctAnswerIds: ['instellingen-checken'],
      explanationKey: 'texts.Tutor_Academy_MoreRequests_Q1_Explanation'
    },
    {
      id: 'vakken-en-leerjaren',
      questionKey: 'texts.Tutor_Academy_MoreRequests_Q2_Question',
      isMultiSelect: false,
      answers: [
        { id: 'per-vak-alle-leerjaren', textKey: 'texts.Tutor_Academy_MoreRequests_Q2_Answer1' },
        { id: 'sterkste-vak', textKey: 'texts.Tutor_Academy_MoreRequests_Q2_Answer2' },
        { id: 'alleen-vakken', textKey: 'texts.Tutor_Academy_MoreRequests_Q2_Answer3' },
        { id: 'bovenbouw', textKey: 'texts.Tutor_Academy_MoreRequests_Q2_Answer4' }
      ],
      correctAnswerIds: ['per-vak-alle-leerjaren'],
      explanationKey: 'texts.Tutor_Academy_MoreRequests_Q2_Explanation'
    },
    {
      id: 'hoger-in-de-lijst',
      questionKey: 'texts.Tutor_Academy_MoreRequests_Q3_Question',
      isMultiSelect: false,
      answers: [
        { id: 'meer-vakken', textKey: 'texts.Tutor_Academy_MoreRequests_Q3_Answer1' },
        { id: 'omzetten-reageren-houden', textKey: 'texts.Tutor_Academy_MoreRequests_Q3_Answer2' },
        { id: 'langere-tekst', textKey: 'texts.Tutor_Academy_MoreRequests_Q3_Answer3' },
        { id: 'zelf-instellen', textKey: 'texts.Tutor_Academy_MoreRequests_Q3_Answer4' }
      ],
      correctAnswerIds: ['omzetten-reageren-houden'],
      explanationKey: 'texts.Tutor_Academy_MoreRequests_Q3_Explanation'
    }
  ]
};
